import { api_GET } from "./_api.js";

const variaveisSistema_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`VariaveisSistema/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default variaveisSistema_api;
